// Shared action button row used by both CreateForecastForm and DayForecastForm.
//
// Three states:
//   canEdit=false         → no buttons shown at all (view-only user or locked date)
//   hasExisting + !editing → single "Edit" button
//   editing / creating    → "Cancel" (if editing existing) + "Submit / Update / Saving..."
import { Button } from "@common";

export default function ForecastFormActions({
  canEdit,
  hasExisting,
  isEditing,
  canSubmit,
  isPending,
  isTransitioning,
  onEdit,
  onCancel,
}) {
  if (!canEdit) return null;

  if (hasExisting && !isEditing) {
    return (
      <div className="flex gap-4 justify-center">
        <Button type="button" variant="primary" onClick={onEdit}>
          Edit
        </Button>
      </div>
    );
  }

  return (
    <div className="flex gap-4 justify-center">
      {/* Cancel is only shown when editing an existing record, not when creating a new one */}
      {hasExisting && (
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      )}
      <Button type="submit" variant="success" disabled={!canSubmit || isPending || isTransitioning}>
        {isPending || isTransitioning ? "Saving..." : hasExisting ? "Update" : "Submit"}
      </Button>
    </div>
  );
}
